import request from "./request";

export function wxShareConfig(nowUrl: string) {
  const params = {
    url: nowUrl
  };
  return request({
    url: "/wechat/jsConfig",
    method: "get",
    params
  });
}
